<template>
  <v-text-field
    ref="inputRef"
    :value="innerValue"
    v-bind="$attrs"
    v-on="$listeners"
    :name="randomName"
    :id="randomName"
    :autocomplete="randomName"
    @change="updateValue"
    :error-messages="errorMessages"
    :clearable="clearable"
  >
    <!-- <template
      v-if="
        clearable !== undefined &&
          clearable !== false &&
          innerValue !== null &&
          innerValue !== undefined
      "
      v-slot:append
    >
      <v-btn rounded small text @click="clear" tabindex="-1">
        <v-icon>clear</v-icon>
      </v-btn>
    </template> -->
  </v-text-field>
</template>

<script>
export default {
  name: "no-autocomplete-textfield",
  props: ["value", "fixedId", "clearable"],
  data() {
    return {
      innerValue: null,
      randomName: "",
      errorMessages: [],
      // trimMonitor: null
    };
  },
  watch: {
    value: {
      handler(v) {
        // console.log("valie:", v)
        this.errorMessages = [];
        // if (v===null || v===undefined) {
        this.innerValue = v;
        // } else {
        //   this.innerValue = v.toString().trim();
        // }
      },
      immediate: true,
    },
    fixedId: {
      handler(v) {
        // console.log("valie: ", v)
        if (v === null || v === undefined) {
          this.randomName = v;
        } else {
          this.randomName = this.getRandomName();
        }
      },
      immediate: true,
    },
    // innerValue: {
    //   async handler(v) {
    //     // const obj = {};
    //     // this.trimMonitor = obj;
    //     // await this.delay(800);
    //     // if (this.trimMonitor !== obj) {
    //     //   console.log("nothing to see here")
    //     //   return;
    //     // }
    //     // if (this.innerValue!==null && this.innerValue!==undefined) {
    //     //   console.log(this.innerValue, JSON.stringify({key: this.innerValue}));
    //     //   this.innerValue = this.innerValue.toString().trim();
    //       console.log(this.innerValue, JSON.stringify({key: this.innerValue}));
    //     // }
    //     this.$emit("change",this.innerValue);
    //   }
    // }
  },
  mounted() {
    if (this.fixedId === null || this.fixedId === undefined) {
      this.randomName = this.getRandomName();
    } else {
      this.randomName = this.fixedId;
    }
  },
  methods: {
    updateValue(v) {
      if (v !== undefined && v !== null) {
        v = v.toString().trim();
      }
      // console.log("updateValue: ", v);
      this.$emit("update:value", v);
    },
    getRandomName() {
      return Math.random().toString();
    },
    // delay(ms) {
    //   return new Promise((resolve) => setTimeout(resolve, ms));
    // }
    clear() {
      console.log("clear");
      this.$emit("update:value", null);
      this.$emit("input", null);
    },
    setText(text) {
      console.log(this.$refs.inputRef.$refs.input);
      var el = this.$refs.inputRef.$refs.input;
      console.log(el);
      el.value = text;
    },
    setErrorMessages(errors) {
      this.errorMessages = errors
    }
  },
};
</script>
